import { render, staticRenderFns } from "./AMEF.vue?vue&type=template&id=354fbeb0&scoped=true"
import script from "./AMEF.vue?vue&type=script&lang=js"
export * from "./AMEF.vue?vue&type=script&lang=js"
import style0 from "./AMEF.vue?vue&type=style&index=0&id=354fbeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fbeb0",
  null
  
)

export default component.exports